/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { userRoles } from '@constants/common';

export const DormantAccountsRoute = {
  path: '/customer/dormant-accounts',
  load: () => import('./dormantAccounts/DormantAccounts'),
  protected: true,
  blacklistedRoles: [userRoles.CAPACITY],
};

export const CustomersRoute = {
  path: '/customer',
  load: () => import('./Customer'),
  protected: true,
  blacklistedRoles: [userRoles.CAPACITY],
};

export const CustomerDetailsRoute = {
  path: '/customer/details/:id',
  load: () => import('./customerDetail/CustomerDetails'),
  protected: true,
  blacklistedRoles: [userRoles.CAPACITY],
};

export const NewCustomerRoute = {
  path: '/customer/create',
  load: () => import('./newCustomer'),
  protected: true,
  blacklistedRoles: [userRoles.CAPACITY],
};

export const NewCustomerWithProspectRoute = {
  path: '/customer/create/:id',
  load: () => import('./newCustomer'),
  blacklistedRoles: [userRoles.CAPACITY],
};
